import { AssetUrl } from './common.types';
import { AdStatus } from '@/types';
import { AdOrderEnum } from '@/components/Shop/Shop.constants';

export enum GalleryItemType {
  Image = 'image',
  YouTube = 'youtube',
}

export interface ShopUser {
  id: string;
  legacyId: string;
}

export interface ShopCategory {
  id: string;
  name: string;
  slug: string;
  path: string;
  count: number;
}

export enum AdKind {
  Bumped = 'BUMPED',
  Premium = 'PREMIUM',
  Vipped = 'VIPPED',
}

export interface AdNode {
  id: string;
  title: string;
  price: number;
  updatedAt: string;
  region: string;
  path: string;
  kinds: AdKind[];
  photo: AssetUrl;
  shop: {
    id: string;
    name: string;
    uri: string;
    workingDays: string;
    workingHours: string;
    logo: AssetUrl;
    phones?: { number: string }[];
    description: string;
  } | null;
  legacyResourceId: number;
  isBookmarked: boolean;
  status: AdStatus;
}

export interface ShopDetails {
  id: string;
  name: string;
  promo: string;
  address: string;
  phones: string[];
  latitude: string;
  longitude: string;
  hits: number;
  adsCount: number;
  description: string;
  uri: string;
  workingDays: string;
  workingHours: string;
  logo: AssetUrl;
  cover: AssetUrl;
  photos: AssetUrl[];
  videos: AssetUrl[];
  user: ShopUser;
  categories: ShopCategory[];
}

export interface ShopAdsResponse {
  ShopAds: ShopAds;
}

export interface PageInfo {
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface AdEdge {
  node: AdNode;
  cursor: string;
}

export interface ShopAds {
  edges: AdEdge[];
  pageInfo: {
    endCursor: string | null;
    hasNextPage: boolean;
  };
  totalCount: number;
}

export interface GalleryImage {
  type: GalleryItemType.Image;
  src: string;
  alt: string;
}

export interface GalleryYoutubeVideo {
  type: GalleryItemType.YouTube;
  videoId: string;
  alt: string;
}

export interface GalleryModalProps {
  items: GalleryItem[];
  activeIndex: number;
  setActiveIndex: (index: number) => void;
  onClose: () => void;
  shopName: string;
  shopWorkTime?: string;
  workingDays?: string;
  phoneNumbers?: string[];
  getPhoneNumbers: () => void;
  isContactsOpen?: boolean;
  toggleContacts?: () => void;
}

export type GalleryItem = GalleryImage | GalleryYoutubeVideo;

export interface ShopGalleryPreviewProps {
  items: GalleryItem[];
  onOpenGallery: (index: number) => void;
}

export interface ShopAdsSectionProps {
  userLegacyId: string;
  categories: ShopCategory[];
}

export interface ShopViewProps {
  data?: ShopDetails;
}

export interface SortBottomSheetProps {
  isOpen: boolean;
  close: () => void;
  selectedSort: AdOrderEnum;
  onSelect: (value: AdOrderEnum) => void;
  text: string;
}
